function DataLink() {
	this.build();
	barbaCallbacks.push(this);
}

DataLink.prototype.build = function(){
	$('[data-link]').on('click', function (e) {
		const target = $(this).attr('target');
		const link = document.createElement('a');
		link.href = $(this).data('link');
		if (e.ctrlKey || e.shiftKey || e.metaKey || (e.button && e.button === 1)) {
			link.target = '_blank';
		} else if (target) {
			link.target = target;
		}
		document.body.appendChild(link);
		link.click();
		link.remove();
	}).on('mouseenter', function(){
		$(this).addClass('is-hovered');
	}).on('mouseleave', function(){
		$(this).removeClass('is-hovered');
	});
};
